import Echo from 'laravel-echo';

import { configureEcho } from '@laravel/echo-react';
import Pusher from 'pusher-js';

window.Pusher = Pusher;

const reverb = {
    broadcaster: 'reverb',
    namespace: '',
    key: import.meta.env.VITE_REVERB_APP_KEY,
    wsHost: import.meta.env.VITE_REVERB_HOST,
    wsPort: import.meta.env.VITE_REVERB_PORT ?? 80,
    wssPort: import.meta.env.VITE_REVERB_PORT ?? 443,
    forceTLS: (import.meta.env.VITE_REVERB_SCHEME ?? 'https') === 'https',
    enabledTransports: ['ws', 'wss'],
};

configureEcho(reverb);

window.Echo = new Echo(reverb);
